// Co-branding per DAM host, GENERATED from the tenant manifest.
//
// This file is read only by bam-frontend, which is served only on the DAM
// distribution (admin-*.bam.zone). Tenant primary domains and custom domains
// are on the mp distribution and serve the Expo app, so entries for those hosts
// could never be consulted -- they were dropped when this became generated,
// along with dead entries for decommissioned tenants.
//
// To change a tenant's favicon/tabTitle/className or its registration and
// policy links, edit bam-api-services/src/constants/tenants.json and run
//   cd bam-api-services && node scripts/sync-tenants.js --write
import { coBrandConfig } from './coBrand.generated'

export default coBrandConfig
